import useSWRInfinite from 'swr/infinite'
import useSWR from 'swr'
import { FetchResponse } from 'utils/fetcher'
import { ApiType } from 'utils/types'
import { apiAuthFetcher } from 'api/goodtrust/api'
import { encodePageQuery } from 'utils/pagination'
import { useMemo } from 'react'
import { getFormDataBodyWithFile } from 'utils/file'

export const directiveDocumentsSpecification = {
  document_type_ids: [8],
}

export function useUserDocumentList() {
  const memoizedBody = useMemo(() => {
    return {
      method: 'POST',
      body: {},
    }
  }, [])

  return useSWRInfinite<FetchResponse<ApiType['PaginatedResponseUserDocumentResponse']>>(
    (_, prev) => [encodePageQuery('/api/v1/user/document/search', prev), memoizedBody],
    apiAuthFetcher
  )
}

export function useUserDocumentSharedWithList() {
  return useSWRInfinite<FetchResponse<ApiType['PaginatedResponseUserDocumentResponse']>>(
    (_, prev) => encodePageQuery('/api/v1/user/document/sharedWithMe', prev),
    apiAuthFetcher
  )
}

export function useUserDocument(documentUuid: string) {
  return useSWR<FetchResponse<ApiType['UserDocumentResponse']>>(
    documentUuid ? `/api/v1/user/document/${documentUuid}` : null,
    apiAuthFetcher
  )
}

export function postUserDocument(request: ApiType['UserDocumentRequest'], file?: File | null) {
  const body = getFormDataBodyWithFile(request, file)
  return apiAuthFetcher<ApiType['UserDocumentResponse']>(`/api/v1/user/document`, {
    method: 'POST',
    body,
  })
}

export function putUserDocument(
  documentUuid: string,
  request: ApiType['UserDocumentUpdateRequest'],
  file?: File | ApiType['FileResponse'] | null
) {
  const body = getFormDataBodyWithFile(request, file)
  return apiAuthFetcher<ApiType['UserDocumentResponse']>(`/api/v1/user/document/${documentUuid}`, {
    method: 'PUT',
    body,
  })
}

export function putUserDocumentContact(
  documentUuid: string | undefined,
  body: ApiType['ItemShareWithTrustedContactRequest']
) {
  return apiAuthFetcher<void>(`/api/v1/user/document/${documentUuid}/trusted-contact`, {
    method: 'PUT',
    body,
  })
}

export function deleteUserDocument(documentUuid: string | undefined) {
  return apiAuthFetcher<void>(`/api/v1/user/document/${documentUuid}`, {
    method: 'DELETE',
  })
}

export function useUserDocumentTypeList() {
  return useSWR<FetchResponse<ApiType['UserDocumentTypeResponse'][]>>(
    '/api/v1/user/document/type',
    apiAuthFetcher
  )
}
